import React, { useState, useContext, useEffect } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import { ThemeContext } from "../../utils/ThemeContext";
import AllUsersTable from "./AllUsersTable";
import PropertyAccountsTable from "./PropertyAccountsTable";
import { PermissionsContext } from "../../utils/PermissionsContext";

const UsersPage = () => {
  const { isDark } = useContext(ThemeContext);
  const permissionsCtx = useContext(PermissionsContext);
  const hasPermission =
    typeof permissionsCtx === "function"
      ? permissionsCtx
      : (perm) => Array.isArray(permissionsCtx) && permissionsCtx.includes(perm);

  const tabConfig = [
    {
      label: "Users",
      component: <AllUsersTable />,
      permission: "view_user_accounts",
    },
    {
      label: "Members Accounts",
      component: <PropertyAccountsTable />,
      permission: "view_member_accounts",
    },
  ];

  const visibleTabs = tabConfig.filter(
    ({ permission }) => !permission || hasPermission(permission)
  );

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_event, newValue) => setTabIndex(newValue);

  useEffect(() => {
    if (tabIndex > visibleTabs.length - 1) setTabIndex(0);
  }, [visibleTabs.length, tabIndex]);

  if (visibleTabs.length === 0) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: "18px",
          border: "1px solid rgba(47,99,173,0.08)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          backgroundColor: "rgba(255,255,255,0.96)",
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 700, color: "#223142", mb: 0.5 }}
        >
          Users
        </Typography>
        <Typography sx={{ color: "#6b778c" }}>
          You do not have permission to view any user pages.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ mb: 3 }}>
       

      
      </Box>

      <Paper
        elevation={0}
        sx={{
          borderRadius: "18px",
          border: isDark ? "1px solid rgba(255,255,255,0.07)" : "1px solid rgba(47,99,173,0.08)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
          backgroundColor: isDark ? "#16223a" : "rgba(255,255,255,0.96)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            px: { xs: 2, md: 3 },
            pt: 2.5,
            pb: 1.5,
            borderBottom: isDark ? "1px solid rgba(255,255,255,0.07)" : "1px solid rgba(47,99,173,0.08)",
            backgroundColor: isDark ? "rgba(255,255,255,0.03)" : "rgba(47,99,173,0.02)",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: isDark ? "#dde5f0" : "#223142",
              mb: 0.5,
            }}
          >
            Users & Accounts
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: isDark ? "#8a9ab8" : "#6b778c",
              mb: 2,
            }}
          >
            Switch between users and member accounts.
          </Typography>

          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="Users Tabs"
            sx={{
              minHeight: "auto",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "10px",
                minHeight: 42,
                color: isDark ? "#8a9ab8" : "#5f6b7a",
                mr: 1,
                px: 2,
              },
              "& .Mui-selected": {
                color: "#2f63ad !important",
                backgroundColor: "rgba(47,99,173,0.08)",
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {visibleTabs.map((tab, idx) => (
              <Tab key={idx} label={tab.label} />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ p: { xs: 2, md: 3 }, width: "100%" }}>
          {visibleTabs[tabIndex]?.component}
        </Box>
      </Paper>
    </Box>
  );
};

export default UsersPage;